// extracted by mini-css-extract-plugin
export default {"CheckboxCell":"CheckboxCell_CheckboxCell__y5mPW"};